import BaseService from "./BaseService";
import {
  WhistleblowerCommentRequest,
  WhistleblowerCommentResponse,
  WhistleblowerCommentsResponse
} from "./mappers/WhistleblowerCommentMapper";

class WhistleblowerCommentService extends BaseService {
  constructor() {
    super();
  }

  createAdminWhistleblowerComment(id, data) {
    return this.post(`whistleblowercomment/createadmin/${id}`, WhistleblowerCommentRequest(data))
      .then((response) => response.data)
      .then((data) => WhistleblowerCommentResponse(data));
  }

  createWhistleblowerComment(guid, password, data) {
    let credentials = {
      guid: guid,
      password: password,
      whistleblowercomment: WhistleblowerCommentRequest(data)
    };
    return this.post(`whistleblowercomment/create/`, credentials)
      .then((response) => response.data)
      .then((data) => WhistleblowerCommentResponse(data));
  }
  getAdminWhistleblowerComments(guid) {
    return this.put(`whistleblowercomment/getadmin/`, { guid: guid })
      .then((response) => response.data)
      .then((data) => WhistleblowerCommentsResponse(data));
  }
  getWhistleblowerComments(guid, password) {
    let credentials = {
      guid: guid,
      password: password
    };
    return this.put(`whistleblowercomment/get/`, credentials)
      .then((response) => response.data)
      .then((data) => WhistleblowerCommentsResponse(data));
  }
}

export default new WhistleblowerCommentService();
